import { useDownloadStore } from "../../../utils/useDownloadStore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

export default function DownloadTrayIcon({ onClick }) {
    const activeDownloads = useDownloadStore((s) => s.activeDownloads);
    const downloading = activeDownloads.some((d) => !d.done);

    return (
        <button
            onClick={onClick}
            title="Download Manager"
            style={{
                position: "relative",
                borderRadius: "9999px",
                padding: "0.5rem 0.75rem",
                fontSize: "16px",
                cursor: "pointer",
                border: "none",
            }}
        >
            <FontAwesomeIcon icon={faDownload} />
            {downloading && (
                <span
                    style={{
                        position: "absolute",
                        top: "0",
                        right: "0",
                        transform: "translate(50%, -50%)",
                        width: "8px",
                        height: "8px",
                        backgroundColor: "red",
                        borderRadius: "9999px",
                        animation: "ping 1s infinite",
                    }}
                />
            )}
        </button>
    );
}
